/*------------------------------------------------------------------
Import Modules
------------------------------------------------------------------*/

import SimpleSelector from 'simple-selector';

/*------------------------------------------------------------------
Document Setup
------------------------------------------------------------------*/

// Create new watchers
const ButtonWatcher = new Watcher();
// Checkbox Watcher
const CheckboxWatcher = new Watcher();
// Select Watcher
const SelectWatcher = new Watcher();
// Input Watcher
// const InputWatcher = new Watcher();

// Whenever the page content changes, check for new buttons to add classes to
ButtonWatcher.on('update', buttons => {
  buttons.forEach(button => {
    console.log(button);
    button.classList.add('button', 'action');
  });
});

// Watch for new hs-button elements
ButtonWatcher.watch('.hbspt-form .hs-button');

// Whenever the page content changes, check for new checkboxes to add classes to
CheckboxWatcher.on('update', checkboxes => {
  checkboxes.forEach(checkbox => {
    // The checkbox parent is a label, we want to add the checkbox to the label's parent
    const label = checkbox.parentNode;
    const parent = label.parentNode;
    parent.insertBefore(checkbox, label);
  });
});

// Watch for new hs-button checkbox elements
CheckboxWatcher.watch('.hbspt-form label input[type="checkbox"], .hbspt-form label input[type="radio"], .hs-form-booleancheckbox input[type="checkbox"]');

// Whenever the page content changes, check for new selects to add classes to
SelectWatcher.on('update', selects => {
  selects.forEach(select => {
    // Create a new input event
    const inputEvent = new Event('input');
    const changeEvent = new Event('change');
    // Create a new selector for this select element
    select.Selector = new SimpleSelector(select, {
      search: true
    });

    // When the select value changes, dispatch an input event (hs require input event)
    select.addEventListener('change', () => select.dispatchEvent(inputEvent));

    // Find the search input in the selector
    const search = select.Selector.template.search;

    // When the user opens the select, focus on the search input
    select.Selector.on('open', () => {
      search.focus();
    });

    // When the user closes the select, focus on the select
    select.Selector.on('close', () => {
      select.focus();
    });

    // When the user presses enter on the search input, focus the first option
    search.addEventListener('keydown', e => {
      // if there is no value, return
      if (search.value == '') return;

      // get the first select.Selector.options that has an input that is not disabled
      const option = select.Selector.options.find(option => {
        return option.input && !option.input.disabled;
      });
      if (!option) return;

      // Select this options
      option.input.checked = true;
      // Update the select value
      select.value = option.input.value;
      if (e.key === 'Enter') {
        e.preventDefault();
        select.dispatchEvent(changeEvent);
        // Close the selector
        select.Selector.close();
      }
    });
  });
});

// Watch for new hs-button select elements
SelectWatcher.watch('.hbspt-form select');

// // Whenever the page content changes, check for new inputs to add classes to
// InputWatcher.on('update', (inputs) => {
//   inputs.forEach((input) => {
//     // Find this input's label
//     const label = document.querySelector(`label[for="${input.id}"]`);
//     // Find the parent
//     const parent = label.parentNode;
//     // Get the label text and set it as the input placeholder
//     const placeholder = label.textContent.trim();

//     // Set the parent to position relative
//     parent.style.position = 'relative';
//     // Add a class to the label
//     label.classList.add('special-label');

//     input.addEventListener('focus', () => {
//       label.classList.add('active');
//       input.placeholder = '';
//     });

//     input.addEventListener('blur', () => {
//       label.classList.remove('active');
//       input.placeholder = placeholder;
//     });
//   });
// });

// /* watch for all these inputs within the form */
// const inputs = [
//   'input[type="tel"]',
//   'input[type="text"]',
//   'input[type="email"]',
//   'input[type="number"]',
//   'input[type="password"]',
//   'input[type="search"]',
//   'input[type="date"]',
//   'textarea'
// ]

// // Loop and prefix all the inputs with .hbspt-form, then convert them to a comma separated string
// const inputSelector = inputs.map((input) => `.hbspt-form ${input}`).join(', ');

// InputWatcher.watch(inputSelector);